import {tagActivity} from '@/helper/analytics'

class ActivityTrackingService {
  public readonly interval = 20000

  private timer?: NodeJS.Timer

  public initialize() {
    this.registerInterval()
    document.addEventListener('visibilitychange', () => this.handleVisibilityChange(), false)
  }

  public trackActivity() {
    tagActivity()
  }

  private registerInterval() {
    if (this.timer) {
      return
    }
    this.timer = setInterval(() => this.trackActivity(), this.interval)
  }

  private unregisterInterval() {
    if (!this.timer) {
      return
    }
    clearInterval(this.timer)
    this.timer = undefined
  }

  private handleVisibilityChange() {
    if (document.visibilityState === 'hidden') {
      this.unregisterInterval()
    } else {
      this.registerInterval()
    }
  }
}

const activityTrackingService = new ActivityTrackingService()
export default activityTrackingService
